const BASE_FORM = {
  'type': 'Tipo TWC',
  'numTwcDealer': 'Número TWC',
  'numFac': 'Número de Factura',
  'orderRepairId': 'Número de orden de reparación',
  'repairDate': 'Fecha de Reparación',
  'chassis': 'VIN Chasis',
  'km': 'Kilometraje',
  'salesDate': 'Fecha de venta',
};

const ACCESORIES_FORM = {
  'previousDate': 'Fecha Fact Anterior',
};

const VEHICLE_FORM = {
  'condition': 'Condición',
  'cause': 'Causa',
  'repair': 'Reparación',
  'task1': 'T1',
  'task2': 'T2',
  'actualDate': 'Fecha Actual',
  'principalPart': 'OFP Parte Principal',
};

const SALES_PARTS_FORM = {
  'previousNumFac': 'No Fact Previa',
  'numFacActual': 'No Fact Actual',
  'actualDate': 'Fecha Actual',
};

const EXTENDED_PARTS_FORM = {
  'actualDate': 'Fecha Actual',
};

const BASE_CAMPAIGN_FORM = {
  'type': 'Tipo TWC',
  'numTwcDealer': 'Número TWC',
  'numFac': 'Número de Factura',
  'orderRepairId': 'Número de orden de reparación',
  'salesDate': 'Fecha de venta del vehículo',
  'km': 'Kilometraje',
  'repairDate': 'Fecha de Reparación',
  'processDate': 'Fecha de Proceso Inicial',
  'openRepairDate': 'Fecha de Apertura de Reparación',
  'endRepairDate': 'Fecha de Finalización de la Reparación',
  'campaignId': 'Campaña',
};

const ACCESORIES_CAMPAIGN_FORM = {
  'previousDate': 'Fecha Fact Anterior',
  'principalPart': 'OFP Parte Principal',
};

const SERVICE_PARTS_CAMPAIGN_FORM = {
  'previousDate': 'Fecha Fact Anterior',
  'numPreviousOrder': 'No Orden Previa',
  'principalPart': 'OFP Parte Principal',
};

const VEHICLE_CAMPAIGN_FORM = {
  'actualDate': 'Fact Actual',
};

const SALES_PARTS_CAMPAIGN_FORM = {
  'numFacActual': 'No Fact Actual',
  'actualDate': 'Fecha Actual',
  'principalPart': 'OFP Parte Principal',
};

const EXTENDED_PARTS_CAMPAIGN_FORM = {
  'actualDate': 'Fecha Actual',
  'principalPart': 'OFP Parte Principal',
};

export const errorFields = (type, hasCampaign) => {
  const base = {...BASE_FORM};
  if (hasCampaign) {
    const baseCampaign = {...BASE_CAMPAIGN_FORM};
    switch (type) {
      case 'AC':
        return {
          ...baseCampaign,
          ...ACCESORIES_CAMPAIGN_FORM,
        };
      case 'P1':
        return {
          ...baseCampaign,
          ...SERVICE_PARTS_CAMPAIGN_FORM,
        };
      case 'VE':
        return {
          ...baseCampaign,
          ...VEHICLE_CAMPAIGN_FORM,
        };
      case 'EX':
        return {
          ...baseCampaign,
          ...EXTENDED_PARTS_CAMPAIGN_FORM,
        };
      default:
        return {
          ...baseCampaign,
          ...SALES_PARTS_CAMPAIGN_FORM,
        };
    }
  } else {
    switch (type) {
      case 'AC':
        return {
          ...base,
          ...ACCESORIES_FORM,
        };
      case 'P1':
        return {
          ...base,
        };
      case 'VE':
        return {
          ...base,
          ...VEHICLE_FORM,
        };
      case 'EX':
        return {
          ...base,
          ...EXTENDED_PARTS_FORM,
        };
      case 'CE':
        return {
          ...base,
        };
      default:
        return {
          ...base,
          ...SALES_PARTS_FORM,
        };
    }
  }
};
